namespace $.$$ {
	export class $easyreels_labeler_moment extends $.$easyreels_labeler_moment {
		override shown_value() {
			return this.value() || '-'
		}
	}
}
